document.addEventListener("DOMContentLoaded", function() {
    // Body Click Events
    document.body.addEventListener('click', function (event) {
        if (event.target.classList.contains('sub-qty') || event.target.classList.contains('add-qty')) {
            trg_updateQuantity(event.target);
        }
    });

    // Cart updated events
    document.addEventListener('product-ajax:added', function (evt) {
        trg_initAutoCloseCartDrawer();
    });

    // Clear auto-close interval when user manually closes the cart drawer
    document.querySelector("#CartDrawer .drawer__close-btn").addEventListener('click', function() {
        clearInterval(trg_autoCloseIntervalId);
    });

    // Cart drawer mouse over events
    document.querySelector("#CartDrawer").addEventListener("mouseover", function() {
        this.classList.add("trg_mouse-over-cart");
    });
    document.querySelector("#CartDrawer").addEventListener("mouseout", function() {
        this.classList.remove("trg_mouse-over-cart");
    });

    // After cart drawer is hidden events
    document.querySelector("#CartDrawer").addEventListener("drawer:handleAfterHide", function() {
        // Remove modal-show from the body as soon as the cart drawer finishes hiding.
        // This fires synchronously before the theme sets hidden=true on the drawer,
        // closing the gap where modal-show's padding-right would briefly flash back in.
        document.body.classList.remove("modal-show");
    });

    // Chat window click event
    document.addEventListener("click", function(event) {
        const target = event.target;

        if ((target.nodeName === 'A' || target.nodeName === 'BUTTON') &&
            target.getAttribute('href') === '#showChatWindow') {
            trg_showChatWindowOnClick(event);
        }
    });

    trg_PreventProductGridSearchOnEnterPress(); 
});


let trg_autoCloseIntervalId = null;

function trg_autoCloseCartDrawer() {
    let cartDrawer = document.getElementById("CartDrawer");

    // If cart is open
    if (cartDrawer.hasAttribute('open')) {
        trg_autoCloseIntervalId = setInterval(function() {

            // If the close button is found, click it after 2 seconds if the mouse is not over the cart drawer
            if (!cartDrawer.classList.contains('trg_mouse-over-cart')) {
                if (document.querySelector("#CartDrawer .drawer__inner").contains(document.querySelector("#CartDrawer .drawer__close-btn"))) {
                    // Clear the activeElement reference on the drawer before closing.
                    // The theme's handleAfterHide calls removeTrapFocus(activeElement) which
                    // calls .focus() on whatever element opened the drawer (e.g. Add to Cart btn).
                    // If that element is off-screen, the browser scrolls to it — clearing
                    // activeElement prevents that focus call from happening at all.
                    cartDrawer.activeElement = null;

                    cartDrawer.addEventListener('drawer:handleAfterHide', function() {
                        document.body.classList.remove("trg_allow-scroll-with-cart-drawer");
                    }, { once: true });

                    document.querySelector("#CartDrawer .drawer__inner .drawer__close-btn").click();
                    clearInterval(trg_autoCloseIntervalId);
                }
            }
        }, 2000);
    
        // Clear interval when cart drawer is removed from DOM
        cartDrawer.addEventListener('DOMNodeRemoved', function() {
            clearInterval(trg_autoCloseIntervalId);
        });
    }
}

function trg_initAutoCloseCartDrawer() {
    document.body.classList.add("trg_allow-scroll-with-cart-drawer");
    let cartDrawer = document.getElementById("CartDrawer");

    window.setTimeout(function() {
        trg_autoCloseCartDrawer();
    }, 500);
}

//-- Custom Quantity Input --//
function trg_updateQuantity(clickedBtn) {
    const quantityInput = clickedBtn.closest('.trg_custom-qty-input').querySelector('.custom-qty-input');

    if (clickedBtn.classList.contains('sub-qty')) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
    } else if (clickedBtn.classList.contains('add-qty')) {
        quantityInput.value = parseInt(quantityInput.value) + 1;
    }
}


//-- Custom Quantity Input --//
function trg_updateQuantity(clickedBtn) {
    const quantityInput = clickedBtn.closest('.trg_custom-qty-input').querySelector('.custom-qty-input');

    if (clickedBtn.classList.contains('sub-qty')) {
        if (parseInt(quantityInput.value) <= parseInt(quantityInput.min)) {
            return;
        }
        quantityInput.value = parseInt(quantityInput.value) - 1;
    } else if (clickedBtn.classList.contains('add-qty')) {
        quantityInput.value = parseInt(quantityInput.value) + 1;
    }
}


document.addEventListener('open', (event) => {
    // Only react to events from <shopify-account>, not other components
    if (event.target.tagName.toLowerCase() === 'shopify-account') {
        console.log('Account sheet opened from', event.target);
    }
});


function trg_PreventProductGridSearchOnEnterPress() {
    const selector = "#ProductGridContainer #gf-controls-container form";

    function attachListener(form) {
        form.addEventListener("submit", function(event) {
            event.preventDefault();
        });
    }

    const existing = document.querySelector(selector);
    if (existing) {
        attachListener(existing);
        return;
    }

    if (!document.querySelector("#ProductGridContainer")) {
        return;
    }

    const observer = new MutationObserver(function() {
        const form = document.querySelector(selector);
        if (form) {
            attachListener(form);
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}


function trg_showChatWindowOnClick(event) {
    event.preventDefault();
    history.pushState({}, document.title, window.location.pathname + window.location.search);
    GorgiasChat.open();
    return false;
}


// Mobile Tap Fix:
// theme.js's global touchend handler calls preventDefault() on every tap that isn't a
// checkbox/radio, which suppresses the browser's native tap-to-click/tap-to-focus behavior
// (including the native drag/scroll disambiguation that comes with it) for that touch. It
// then only restores the interaction with a manually-dispatched synthetic click, using
// event.target.closest('a, button, label, select, summary, [role="button"]') to decide
// whether to do so. Two kinds of elements fall through that check on real touch devices
// (not devtools emulation), losing all tap/focus behavior with nothing to replace it:
//   1. Text inputs (e.g. .search__input.form-control) and elements styled like buttons
//      without one of those tags/roles (e.g. .account-button, the <span> used as the mobile
//      menu's "Log In" trigger inside <shopify-account>) — simply not in the allowlist.
//   2. Anything inside a shadow root — e.g. the <dialog> that <shopify-account> opens for
//      "Sign in or create account" renders its real buttons inside its own shadow DOM, so a
//      tap there gets event.target *retargeted* to the <shopify-account> host element for
//      any listener outside that shadow tree (that's how composed events work). theme.js's
//      closest() call — and event.target.closest() anywhere outside the shadow tree — sees
//      only the host, never the actual button, so the allowlist check can never match no
//      matter what's really being tapped in there. event.composedPath()[0] gives the true,
//      un-retargeted element that was tapped, bypassing that problem.
// Running in the capture phase here stops the touchend from ever reaching theme.js's
// bubble-phase listener on document for these elements, so the browser's own native tap
// handling (focus, click, or delivering the touch to the real shadow-DOM target) fires
// instead, without editing theme.js directly.
document.addEventListener('touchend', function (event) {
    const target = event.composedPath()[0];
    const insideShadowRoot = target.getRootNode && target.getRootNode() instanceof ShadowRoot;
    if (insideShadowRoot || (target.closest && target.closest('input, textarea, select, .account-button'))) {
        event.stopPropagation();
    }
}, { capture: true, passive: true });


// Sticky Add-to-Cart Bar Quantity Fix:
// sections/sticky-atc-bar.liquid is `position: fixed` (assets/section-sticky-atc-bar.css).
// Focusing a text input inside a fixed-position ancestor is a known mobile Safari/Chrome
// quirk: the browser computes where to scroll the page to reveal the focused input using
// its un-fixed flow position rather than its actual fixed one, so the page jumps to wherever
// that input "would" sit in normal document flow — landing on/around the inline quantity
// selector further down sections/trg_main-product.liquid.
// Two earlier attempts at this didn't hold up:
//   1. Re-locking the scroll position on every 'scroll' event for as long as the input was
//      focused fought ALL scrolling during that time, not just the unwanted jump — the user
//      couldn't scroll the page at all once the field was focused.
//   2. Temporarily switching the bar to `position: absolute` (pinned via a computed `top`)
//      assumed its containing block was the document root; it wasn't, so the bar landed at
//      the wrong spot on the page instead of staying near the keyboard.
// This version keeps the scroll-correction idea from #1 but bounds it to a short window
// after focus (long enough to cancel the keyboard-open jump, which happens asynchronously as
// the keyboard animates in) instead of the entire time the field is focused. After that
// window, scrolling is left completely alone — the user can scroll normally while still
// typing, and only the initial jump gets undone.
(function () {
    const JUMP_CORRECTION_WINDOW_MS = 600;
    let lockedScrollY = null;
    let unlockTimer = null;

    document.addEventListener('focusin', function (event) {
        if (!event.target.closest || !event.target.closest('.sticky-atc-bar .quantity__input')) return;
        lockedScrollY = window.scrollY;
        clearTimeout(unlockTimer);
        unlockTimer = setTimeout(function () {
            lockedScrollY = null;
        }, JUMP_CORRECTION_WINDOW_MS);
    });

    document.addEventListener('focusout', function (event) {
        if (!event.target.closest || !event.target.closest('.sticky-atc-bar .quantity__input')) return;
        lockedScrollY = null;
        clearTimeout(unlockTimer);
    });

    window.addEventListener('scroll', function () {
        if (lockedScrollY !== null && window.scrollY !== lockedScrollY) {
            window.scrollTo(window.scrollX, lockedScrollY);
        }
    });
})();


// Sticky Add-to-Cart Bar Quantity Sync:
// The sticky bar (sections/sticky-atc-bar.liquid) and the inline product page buy box
// (snippets/trg_buy-buttons.liquid) each render their own independent <quantity-input> web
// component (assets/theme.js QuantityInput), scoped by a different data-section-id.
// QuantityInput's pubsub handlers explicitly ignore updates whose sectionId doesn't match
// their own (theme.js:1309,1361 — `if (sectionId !== this.sectionId ...) return;`), so
// nothing keeps their typed/stepped values in sync even though, to the shopper, they're both
// just "how many am I adding" for the same product.
//
// Scoped to exactly these two inputs (.sticky-atc-bar and .main-product-form) rather than
// every .quantity__input on the page — that class is reu`sed by cart line-item quantity
// steppers (sections/trg_cart-drawer.liquid, trg_main-cart.liquid) and the quick-order list
// (snippets/quick-order-list-row.liquid); syncing against those would misfire an unrelated
// cart-quantity update instead of just mirroring the "how many am I adding" value.
//
// Listens on 'input' (not just 'change') so a typed value is captured immediately, not only
// once the field blurs — on mobile, tapping "Add to Cart" right after typing can dispatch a
// synthetic click without a real native blur/change ever firing first (theme.js's touchend
// handler calls preventDefault() before dispatching that synthetic click, which suppresses
// the browser's own focus-shift-triggered blur), so waiting for 'change' alone could still
// submit a stale value. Mirroring on every keystroke means the other input — and, via
// requestSubmit()-based submission paths, its own form — always has the live value already.
(function () {
    const quantityInputsSelector = '.sticky-atc-bar .quantity__input, .main-product-form .quantity__input';
    let syncing = false;

    function syncQuantityInputs(event) {
        if (syncing) return;
        const changedInput = event.target;
        if (!changedInput.matches || !changedInput.matches(quantityInputsSelector)) return;

        document.querySelectorAll(quantityInputsSelector).forEach(function (otherInput) {
            if (otherInput === changedInput || otherInput.value === changedInput.value) return;
            syncing = true;
            otherInput.value = changedInput.value;
            otherInput.dispatchEvent(new Event('change', { bubbles: true }));
            syncing = false;
        });
    }

    document.addEventListener('input', syncQuantityInputs);
    document.addEventListener('change', syncQuantityInputs);
})();


// Sticky Add-to-Cart Bar Quantity Reset:
// After a successful add-to-cart — product-ajax:added, dispatched on document by
// ProductForm (theme.js:2734-2742) for both the sticky bar's and the inline page's forms —
// the sticky bar's quantity should go back to its minimum instead of continuing to show
// however many the shopper just added. Reset it and dispatch 'change' so its own
// QuantityInput re-validates its button states; the quantity-sync fix above mirrors the
// reset into the inline quantity input too.
document.addEventListener('product-ajax:added', function () {
    const stickyQuantityInput = document.querySelector('.sticky-atc-bar .quantity__input');
    if (!stickyQuantityInput) return;

    const resetValue = stickyQuantityInput.min || '1';
    if (stickyQuantityInput.value === resetValue) return;

    stickyQuantityInput.value = resetValue;
    stickyQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
});

